import { Component, OnDestroy, OnInit } from '@angular/core';
import { ResultListDto, AppRoleDto } from '../../../service/dto';
import { Router } from '@angular/router';
import { HttpAppRoleService } from '../../../service/http-app-role.service';

@Component({
	selector: 'app-role-list',
	standalone: false,
	templateUrl: './role-list.component.html',
	styleUrl: './role-list.component.scss'
})
export class RoleListComponent implements OnInit {
	data: AppRoleDto[] = [];
	constructor(private httpService: HttpAppRoleService, private router: Router) {
	}
	ngOnInit(): void {
		this.httpService.getAll().subscribe(result => this.data = result);
	}



	add() {
		this.router.navigate(['/role', 'new']);
	}
	openRole(input: AppRoleDto) {
		this.router.navigate(['/role', input.id,'edit']);
	}
}
